<template>
  <v-container class="filter-status-boxes">
    <v-row>
      <v-checkbox
        v-for="filter in filters"
        :key="filter.key"
        class="mr-2"
        v-model="filter.isSelected"
        :label="filter.label"
        @change="handleChange($event, filter.key)"
      />
    </v-row>
  </v-container>
</template>

<script>
// vuex
import { mapActions, mapGetters } from 'vuex'
// library
import _ from 'lodash'
// internal
// components
export default {
  name: 'SearchFilterStatusBoxes',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['projectStatusFilters']),
    filters() {
      return Object.keys(this.projectStatusFilters).map(key => {
        return {
          key,
          isSelected: this.projectStatusFilters[key].isSelected,
          label: this.projectStatusFilters[key].label
        }
      })
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(['setProjectStatusFilters']),
    handleChange(value, key) {
      const newFilters = _.cloneDeep(this.projectStatusFilters)
      const newQuery = _.omit(this.$route.query, ['ex'])
      newFilters[key].isSelected = value

      const newEx = Object.keys(newFilters).filter(key => {
        return newFilters[key].isSelected === false
      })
      if (!_.isEmpty(newEx)) {
        newQuery['ex'] = newEx.join(',')
      }
      this.$router.history.push({ path: '/', query: newQuery })
      this.setProjectStatusFilters(newFilters)
    }
  }
}
</script>

<style lang="scss" scoped></style>
